import { logger } from '../logger';

/**
 * Logger for authentication and authorization
 * Use this for login, logout, token refresh, and permission checks
 */
const authLogger = logger.child('Auth');

export default authLogger;
